import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../app.config';
import { urlJoin } from '../../../../core/helpers/url.helper';
import { DerogationRequest } from './exemption.component.model';
import { Observable } from 'rxjs';
import { createHeadersWithGlobalUuid } from '@tribeauto/ngx-mobilite-material';
import { LogService } from '../../../../core/services/log/log.service';
import { ApplicationStore } from '../../../../core/services/application-store.service';

@Injectable({
  providedIn: 'root'
})
export class ExemptionService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);
  private readonly logService = inject(LogService);
  private readonly applicationStore = inject(ApplicationStore);

  private readonly url = urlJoin(this.appConfig.url, 'contract');

  saveDerogation(numAuto: string, derogationRequest: DerogationRequest): Observable<void> {
    const headers = createHeadersWithGlobalUuid(this.logService.sessionUuid()).append(
      'loginId',
      this.applicationStore.instant('userData')()?.jossoLogin ?? ''
    );
    return this.httpClient.post<void>(urlJoin(this.url, numAuto, 'derogation'), derogationRequest, { headers });
  }
}
